<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<p class="copya">To Colleen and Jake Friesen and Colin and Maggie Jamieson</p>
<p class="copyt">F<span class="smallcaps">RONTISPIECE</span>: King Charles I, the ‘father’ of <em class="italic">Sovereign of the Seas</em>. Reproduction of a portrait by Anthony van Dyck (made <em class="italic">circa</em> 1632–35). (© National Maritime Museum, London PAH6073)</p>
<p class="copyt">Copyright © John McKay 2020</p>
<p class="copy1">This edition first published in Great Britain in 2020 by</p>
<p class="copy">Seaforth Publishing,</p>
<p class="copy">An imprint of Pen &amp; Sword Books Ltd,</p>
<p class="copy">47 Church Street,</p>
<p class="copy">Barnsley</p>
<p class="copy">South Yorkshire S70 2AS</p>
<p class="copy1"><span class="weblink"><a href="http://www.seaforthpublishing.com" target="_blank"><span class="underline">www.seaforthpublishing.com</span></a></span></p>
<p class="copy">Email: <span class="weblink"><a href="mailto:info@seaforthpublishing.com"><span class="underline">info@seaforthpublishing.com</span></a></span></p>
<p class="copy1"><em class="italic">British Library Cataloguing in Publication Data</em></p>
<p class="copy">A catalogue record for this book is available from the British Library</p>
<p class="copy1">ISBN 978 1 5267 6629 8 (Hardback)</p>
<p class="copy">ISBN 978 1 5267 6630 4 (ePub)</p>
<p class="copy">ISBN 978 1 5267 6631 1 (Kindle)</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or any information storage and retrieval system, without prior permission in writing of both the copyright owner and the above publisher.</p>
<p class="copy1">The right of John McKay to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988</p>
<p class="copy1">Pen &amp; Sword Books Limited incorporates the imprints of Atlas, Archaeology, Aviation, Discovery, Family History, Fiction, History, Maritime, Military, Military Classics, Politics, Select, Transport, True Crime, Air World, Frontline Publishing, Leo Cooper, Remember When, Seaforth Publishing, The Praetorian Press, Wharncliffe Local History, Wharncliffe Transport, Wharncliffe True Crime and White Owl.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?60db1c7e